// extracted by mini-css-extract-plugin
export default {"heading":"T9l5dwG3","portrait":"mU2WNDOp","teamMember":"OEboWgsq"};